import * as tslib_1 from "tslib";
import { Component, Prop, Vue } from "vue-property-decorator";
let PointContainer = class PointContainer extends Vue {
    get pointCardArr() {
        return this.questionTypeList.map((t) => t);
    }
    deleteQuestion(quesType) {
        // if (this.paperInfo.participateCount > 0) {
        //   this.$message.error("有人参与的试卷禁止移除题型")
        // } else {
        //   this.$emit("delete-question-type", {
        //     type: quesType.type
        //   })
        // }
        this.$emit("delete-question-type", {
            type: quesType.type
        });
    }
};
tslib_1.__decorate([
    Prop({ type: Array, default: () => [] })
], PointContainer.prototype, "questionTypeList", void 0);
tslib_1.__decorate([
    Prop({ type: Number, default: 0 })
], PointContainer.prototype, "questionCount", void 0);
tslib_1.__decorate([
    Prop({ type: Object, default: () => { } })
], PointContainer.prototype, "paperInfo", void 0);
tslib_1.__decorate([
    Prop({ type: Number, default: 0 })
], PointContainer.prototype, "paperScore", void 0);
tslib_1.__decorate([
    Prop({ type: Boolean, default: false })
], PointContainer.prototype, "showDeleteIcon", void 0);
PointContainer = tslib_1.__decorate([
    Component({
        name: 'PointContainer',
        filters: {
            computedScore(arr) {
                var score = 0;
                arr.forEach((item) => {
                    score += parseFloat(item.score);
                });
                score = 10 * Number(score.toFixed(1)) / 10;
                return score;
            }
        }
    })
], PointContainer);
export default PointContainer;
